import { cn } from "lib/utils";

const TONE_CLASSES: Record<string, string> = {
  green: "bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/15",
  yellow: "bg-yellow-50 text-yellow-700 ring-1 ring-inset ring-yellow-600/15",
  red: "bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/15",
  slate: "bg-slate-100 text-slate-600 ring-1 ring-inset ring-slate-500/10",
  blue: "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/15",
};

type Props = {
  label: string;
  tone?: keyof typeof TONE_CLASSES;
  className?: string;
};

const StatusBadge = ({ label, tone = "slate", className }: Props) => (
  <span
    className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium whitespace-nowrap",
      TONE_CLASSES[tone],
      className
    )}
  >
    {label}
  </span>
);

export default StatusBadge;
